import { render, staticRenderFns } from "./value-card-view.vue?vue&type=template&id=6fc8e838&scoped=true"
import script from "./value-card-view.vue?vue&type=script&lang=ts"
export * from "./value-card-view.vue?vue&type=script&lang=ts"
import style0 from "./value-card-view.vue?vue&type=style&index=0&id=6fc8e838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc8e838",
  null
  
)

export default component.exports